import { useEffect, useRef } from "react";

export default function WaterCanvas() {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let raf;
        let time = 0;
        const ripples = [];
        let lastSpawn = 0;

        const resize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight * 0.42;
        };
        resize();
        window.addEventListener("resize", resize);

        const onMove = (e) => {
            const now = performance.now();
            if (now - lastSpawn < 140) return;
            const rect = canvas.getBoundingClientRect();
            if (e.clientY > rect.top) {
                lastSpawn = now;
                ripples.push({ x: e.clientX, r: 4, alpha: 0.22 });
            }
        };
        window.addEventListener("mousemove", onMove);

        const draw = () => {
            const w = canvas.width;
            const h = canvas.height;
            ctx.clearRect(0, 0, w, h);

            const gradient = ctx.createLinearGradient(0, 0, 0, h);
            gradient.addColorStop(0, "rgba(45, 95, 85, 0.0)");
            gradient.addColorStop(0.25, "rgba(80, 150, 135, 0.30)");
            gradient.addColorStop(0.6, "rgba(50, 115, 100, 0.45)");
            gradient.addColorStop(1, "rgba(20, 60, 52, 0.75)");
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, w, h);

            const surface = ctx.createLinearGradient(0, h * 0.18, 0, h * 0.42);
            surface.addColorStop(0, "rgba(255, 250, 230, 0.10)");
            surface.addColorStop(1, "rgba(255, 250, 230, 0)");
            ctx.fillStyle = surface;
            ctx.fillRect(0, h * 0.18, w, h * 0.24);

            for (let i = 0; i < 6; i++) {
                ctx.beginPath();
                ctx.strokeStyle = `rgba(240, 248, 238, ${0.09 + Math.sin(time + i * 0.8) * 0.05})`;
                ctx.lineWidth = 1.6;
                for (let x = 0; x < w; x += 4) {
                    const y = h * 0.25 +
                        Math.sin(x * 0.008 + time + i) * 18 +
                        Math.sin(x * 0.015 + time * 1.3 + i) * 9 +
                        Math.sin(x * 0.003 + time * 0.7) * 25;
                    if (x === 0) ctx.moveTo(x, y);
                    else ctx.lineTo(x, y);
                }
                ctx.stroke();
            }

            for (let i = 0; i < 3; i++) {
                const sx = (Math.sin(time * 0.5 + i * 2.1) * 0.5 + 0.5) * w;
                const sy = h * 0.4 + Math.sin(time * 0.8 + i) * 20;
                const g = ctx.createRadialGradient(sx, sy, 0, sx, sy, 120);
                g.addColorStop(0, `rgba(255, 220, 160, ${0.04 + Math.sin(time + i) * 0.02})`);
                g.addColorStop(1, "rgba(255, 220, 160, 0)");
                ctx.fillStyle = g;
                ctx.fillRect(0, 0, w, h);
            }

            for (let i = ripples.length - 1; i >= 0; i--) {
                const rp = ripples[i];
                ctx.beginPath();
                ctx.arc(rp.x, h * 0.35, rp.r, 0, Math.PI * 2);
                ctx.strokeStyle = `rgba(220, 235, 210, ${rp.alpha})`;
                ctx.lineWidth = 1;
                ctx.stroke();
                rp.r += 1.6;
                rp.alpha *= 0.96;
                if (rp.alpha < 0.01) ripples.splice(i, 1);
            }

            time += 0.012;
            raf = requestAnimationFrame(draw);
        };
        draw();

        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener("resize", resize);
            window.removeEventListener("mousemove", onMove);
        };
    }, []);

    return <canvas ref={canvasRef} data-testid="water-canvas" className="water-canvas" />;
}
